import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ServicePlugin from './plugins/service'
import router from './router'
import store from './store'
import wx from 'weixin-js-sdk'
import '@/assets/global.styl'
import Vant from 'vant'
import VueClipboard from 'vue-clipboard2'
import 'vant/lib/index.css'
import service from './service'
import '@/components'
import 'amfe-flexible'
import VueWechatTitle from 'vue-wechat-title'
import constants from './utils'
// import './utils/buriedPoint'
const env = process.env.NODE_ENV
const isDev = env === 'development'
const isBeta = location.host.indexOf('beta') === 0
if (isDev || isBeta) {
  const vconsole = document.createElement('script')
  vconsole.src = 'https://cdn.bootcdn.net/ajax/libs/vConsole/3.3.4/vconsole.min.js'
  vconsole.onload = function () {
  // eslint-disable-next-line
  new window.VConsole()
  }
  document.head.appendChild(vconsole)
}
Vue.prototype.$constants = constants
Vue.use(VueClipboard)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(ServicePlugin)
Vue.use(VueRouter)
Vue.use(Vant)
Vue.prototype.$wx = wx
service.init((state) => {
  new Vue({
    service,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
